import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DynamicFormComponent } from "../../../shared/components/dynamic-form/dynamic-form.component";
import { QuestionBase } from "../../../shared/components/dynamic-form/question-base";
import { NotificationService } from "../../../shared/components/notification/notification.service";
import { LoginLayoutData } from "../index-layout/index-layout.type";
import { RegisterService } from "./register.service";
import { RegisterUser } from "./register.type";

@Component({
  selector: "app-login",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.css"],
  providers: [RegisterService],
})
export class RegisterComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  @Output() adminHeader: EventEmitter<boolean> = new EventEmitter();

  loading = false;
  questions: QuestionBase<string | boolean>[];
  layoutData: LoginLayoutData = {
    image: "assets/GlobeLogo.svg",
    title: "Create Account",
    boxStyles: {
      margin: "2rem 0 2rem",
    },
  };

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private authService: AuthenticationService,
    private questionsService: RegisterService,
  ) {
    this.questionsService.generateQuestions().subscribe((qs) => {
      this.questions = qs;
    });
    if (this.authenticationService.currentUserInfo) {
      this.router.navigate(["/dashboard"]);
    } else {
      this.router.navigate(["/signup"]);
    }
  }

  ngOnInit(): void {}

  onSubmit(data: RegisterUser): void {
    this.removeEmptyValues(data);
    this.loading = true;
    this.authService
      .registerUser(data)
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        () => {
          this.notificationService.success("Your user has been created, you will receive your login details shortly.");
          this.loading = true;
          this.router.navigate(["/login"]);
        },
        (error) => {
          console.error(error);
          const err = error || "Error logging in user";
          this.notificationService.error(err);
          this.loading = false;
        },
      );
  }

  private removeEmptyValues(data: RegisterUser): void {
    if (data.phone?.length === 0) {
      delete data.phone;
    }
  }
}
